import { useLayoutEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export const SheetShell = ({
  open,
  onClose,
  title,
  children,
  scrollRef,
  restoreScrollTop,
  heightClass = "top-[8%]",
  closeLabel = "Close",
}) => {
  useLayoutEffect(() => {
    if (!open || !scrollRef?.current) return;
    const top =
      typeof restoreScrollTop === "number" ? restoreScrollTop : 0;
    scrollRef.current.scrollTop = top;
  }, [open, scrollRef, restoreScrollTop]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] h-[100svh] max-h-[100svh] w-full max-w-full overflow-hidden overscroll-none xl:hidden"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        className="absolute inset-0 border-none bg-[rgba(15,23,42,0.42)]"
        aria-label={closeLabel}
        onClick={onClose}
      />
      <div
        className={`absolute inset-x-0 bottom-0 ${heightClass} flex max-h-full w-auto max-w-full flex-col overflow-hidden rounded-t-[14px] bg-white shadow-[0_-12px_40px_rgba(15,23,42,0.18)]`}
      >
        <div className="flex flex-shrink-0 items-center gap-2 px-3 pt-2 pb-1">
          <div className="mx-auto h-1 w-10 rounded-full bg-[#d6dae0]" aria-hidden />
        </div>
        <div className="flex flex-shrink-0 items-center justify-between gap-2 border-b border-[#e5e8ec] px-3 pb-2">
          <h2 className="text-[15px] font-bold tracking-[-0.01em] text-[#14171c]">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="grid h-11 w-11 place-items-center rounded-[10px] text-[#59616d] hover:bg-[#eef0f3]"
            aria-label={closeLabel}
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div ref={scrollRef} className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
          {children}
        </div>
      </div>
    </div>
  );
};
